import { render, staticRenderFns } from "./ProfileBody.vue?vue&type=template&id=61536ffd&scoped=true"
import script from "./ProfileBody.vue?vue&type=script&lang=js"
export * from "./ProfileBody.vue?vue&type=script&lang=js"
import style0 from "./ProfileBody.vue?vue&type=style&index=0&id=61536ffd&prod&lang=scss&scoped=true"
import style1 from "./ProfileBody.vue?vue&type=style&index=1&id=61536ffd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61536ffd",
  null
  
)

export default component.exports